import React, { useState, useEffect } from 'react';
import { Alert, Space, Form, Select, Spin } from 'antd';
import useILTInstructors from '../../gql/hooks/useILTInstructors';
import ILTInstructorAddModal from './ILTInstructorAddModal';
import './styles.less';

const ILTInstructorDropDown = ( { hideSpinner = true } ) => {
    const { instructors, instructorsLoading, instructorsError } = useILTInstructors();
    const [ instructorsList, setInstuctorList ] = useState( [] );
    const [ open, setOpen ] = useState( false );
 
    useEffect( () => {
        if ( instructors ) {
            setInstuctorList( instructors );
        }
    }, [ instructors ] );

    const addedInstructorCallback = ( item ) => {
        setInstuctorList( [ item, ...instructorsList ] );
    };

    return (
        <div className="ilt-instructor-drop-down">
            { instructorsLoading && !hideSpinner &&                                                 
                <Spin/>
            }
            
            { instructorsError && 
                <Alert 
                    type="error"
                    message="An unknown error occurred. Please try again later." 
                />
            }

            { !instructorsLoading && !instructorsError &&
                <Space>
                    <Form.Item 
                        label="Instructors"
                        name="instructorIDs"
                        rules={ [
                            { 
                                required: true,
                                message: 'Instructor(s) are required' 
                            }
                        ] }
                    >
                        <Select
                            mode="multiple" 
                            showSearch
                            open={ open }
                            onDropdownVisibleChange={ ( visible ) => setOpen( visible ) }
                            onChange={ () => setOpen( false ) }
                            style={ { width: 300 } } 
                            placeholder="Select Instructors" 
                            filterOption={ ( input, option ) => 
                                ( option?.children ? 
                                    option.children[ 0 ].type ? '' : option.children[ 0 ]
                                    : '' ).toLowerCase().includes( input.toLowerCase() )
                            }
                        >
                            {
                                instructorsList.map( i => {
                                    return ( 
                                        <Select.Option 
                                            key={ i.id } 
                                            value={ i.id }  
                                        >
                                            { i.name || <span className='italic'>No Name</span> }
                                        </Select.Option>
                                    );
                                } )
                            }
                        </Select>
                    </Form.Item>
                    
                    <ILTInstructorAddModal addedCallback={ addedInstructorCallback }/>
                </Space>
            }
        </div>
    );
};

export default ILTInstructorDropDown;
